<template>
    <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData">
            <el-form-item>
                <el-input
                    v-model="formData.remark"
                    :rows="4"
                    size="small"
                    type="textarea"
                    style="width: 460px;"
                    placeholder="输入备注内容"
                >
                </el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            loading: false
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Object,
            default: () => {}
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm() {
            let obj = {};
            obj.id = this.formData.id;
            obj.remark = this.formData.remark;
            this.loading = true;
            api.remark(obj)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            message: "备注成功",
                            type: "success"
                        });
                        this.handleClose(false);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面！"
                    });
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 700;
    margin-bottom: 8px;
}
/deep/ .el-form-item {
    margin-bottom: 6px !important;
}
</style>
